import { FC, useState } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { clsx, Showable } from '@sweatpals/react-ui-kit';

export interface ReadMoreProps {
	text: string;
	readMoreTextOpen?: string;
	readMoreTextClose?: string;
	sx?: SxProps<Theme>;
	textSx?: SxProps<Theme>;
	readMoreSx?: SxProps<Theme>;
	shortTextLength?: number;
	renderText?: (showedText: string) => JSX.Element;
	renderButton?: (expanded: boolean, text: string) => JSX.Element;
}

export const TextWithReadMore: FC<ReadMoreProps> = props => {
	const {
		sx,
		text,
		shortTextLength = 100,
		renderText,
		renderButton,
		readMoreTextClose = 'Read Less',
		readMoreTextOpen = 'Read More',
		textSx,
		readMoreSx,
	} = props;

	const [expanded, setExpanded] = useState(false);

	const shortText = text.slice(0, shortTextLength);

	const isTextMoreThanShort = text.length > shortTextLength;

	const showedText = expanded ? text : shortText;

	const buttonText = expanded ? readMoreTextClose : readMoreTextOpen;

	return (
		<Box sx={sx}>
			{renderText ? (
				renderText(showedText)
			) : (
				<Typography component='div' sx={clsx({ display: 'inline' }, textSx)}>
					{showedText}
				</Typography>
			)}

			<Showable show={isTextMoreThanShort}>
				{renderButton ? (
					renderButton(expanded, showedText)
				) : (
					<Box component='a' sx={clsx({ display: 'inline' }, readMoreSx)} onClick={() => setExpanded(s => !s)}>
						{buttonText}
					</Box>
				)}
			</Showable>
		</Box>
	);
};
